<template>
  <div class="row" style="margin-top: 50px">
    <div class="col col-md-10 offset-md-1 text-center">
      <div class="row">
        <div class="col col-md-8 offset-md-2 text-center">
          <div
            style="margin-bottom: 15px"
            v-bind:class="{
              'd-flex': true,
              'justify-content-between': retornaSite() !== 'Share',
              'justify-content-center': retornaSite() == 'Share',
            }"
          >
            <span>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                data-toggle="modal"
                data-target="#dialogEdit"
                @click="itemNovo()"
                style="margin-right: 10px"
              >
                Novo
              </button>
              <button
                type="button"
                class="btn btn-sm"
                v-bind:class="{
                  'btn-secondary': tab,
                  'btn-outline-secondary': !tab,
                }"
                @click="mostrarTab()"
                v-if="retornaSite() !== 'Share' && !pesquisaAtiva"
                style="margin-right: 10px"
              >
                Abas
              </button>
              <button
                type="button"
                class="btn btn-sm btn-secondary"
                @click="importarWilliamHill()"
                v-if="retornaSite() !== 'Share' && retornaSite() !== 'ShareApp'"
                style="margin-right: 10px"
              >
                WH
              </button>
              <button
                type="button"
                class="btn btn-sm btn-secondary"
                @click="exportItens()"
                v-if="retornaSite() == 'Weddbets'"
                style="margin-right: 10px"
                title="Exportar Eventos"
              >
                Exp
              </button>
              <button
                type="button"
                class="btn btn-sm btn-secondary"
                @click="exportItens(false)"
                v-if="retornaSite() == 'Weddbets'"
                style="margin-right: 10px"
                title="Exportar Resumo dos Eventos"
              >
                ExpR
              </button>
            </span>
            <button
              type="button"
              class="btn btn-outline-secondary btn-sm"
              data-toggle="modal"
              data-target="#dialogEditEventos"
              @click="clickSelecionados()"
              v-if="itensSelecionados.length > 0 && retornaSite() !== 'Share'"
            >
              {{
                itensSelecionados.length == 0
                  ? "-"
                  : itensSelecionados.length.toString() + " selecionados"
              }}
            </button>
          </div>

          <div
            v-bind:class="{
              'd-flex': retornaSite() !== 'ShareApp',
              'd-none': retornaSite() == 'ShareApp',
            }"
          >
            <div class="">
              <Combo
                :itens="$global.sites_filtro()"
                v-model="filtroSite"
                style="max-width: 150px; margin-right: 10px"
                @change="carregarItens(false)"
                v-if="retornaSite() !== 'Share' && retornaSite() !== '7live'"
              />
            </div>

            <div class="flex-grow-1">
              <input
                class="form-control"
                type="text"
                placeholder="Pesquise..."
                v-model="filtroTexto"
                @keyup="keyupFiltroTexto"
                style="min-width: 300px"
                v-bind:class="{
                  inputPesquisaDupla:
                    retornaSite() !== 'Share' &&
                    retornaSite() !== 'Stream1x2' &&
                    retornaSite() !== '7live',
                }"
                autocomplete="off"
              />
            </div>
          </div>

          <hr
            v-bind:class="{
              'd-none': retornaSite() == 'ShareApp',
            }"
          />
        </div>
      </div>

      <div
        v-if="visualizacaoAba"
        class="d-flex justify-content-center"
        style="margin-bottom: 10px"
        role="group"
        aria-label="Basic example"
      >
        <button
          type="button"
          style="margin-right: 5px; min-width: 90px"
          class="btn btn-sm"
          v-bind:class="{
            'btn-dark': abaSelecionada == 'aovivo',
            'btn-outline-dark': abaSelecionada !== 'aovivo',
          }"
          @click="trocarAba('aovivo')"
        >
          Ao vivo
        </button>
        <button
          type="button"
          style="margin-right: 5px; min-width: 90px"
          class="btn btn-sm"
          v-bind:class="{
            'btn-dark': abaSelecionada == 'previsto',
            'btn-outline-dark': abaSelecionada !== 'previsto',
          }"
          @click="trocarAba('previsto')"
        >
          Previsto
        </button>
        <button
          type="button"
          style="margin-right: 5px; min-width: 90px"
          class="btn btn-sm"
          v-bind:class="{
            'btn-dark': abaSelecionada == 'invisivel',
            'btn-outline-dark': abaSelecionada !== 'invisivel',
          }"
          @click="trocarAba('invisivel')"
        >
          Invisivel
        </button>
        <button
          type="button"
          style="margin-right: 5px; min-width: 90px"
          class="btn btn-sm"
          v-bind:class="{
            'btn-dark': abaSelecionada == 'finalizado',
            'btn-outline-dark': abaSelecionada !== 'finalizado',
          }"
          @click="trocarAba('finalizado')"
        >
          Finalizado
        </button>
      </div>

      <h2
        class="tituloJogos"
        v-if="retornaSite() !== 'Share' && visualizacaoAba == false"
      >
        Ao vivo
      </h2>

      <p
        v-if="
          itensAoVivo.length == 0 &&
          retornaSite() !== 'Share' &&
          (visualizacaoAba == false || abaSelecionada == 'aovivo')
        "
        style="margin-bottom: 0px"
      >
        ------
      </p>

      <div
        class="rowLista"
        :style="{
          display:
            visualizacaoAba == false || abaSelecionada == 'aovivo'
              ? 'block'
              : 'none',
        }"
      >
        <ListEventos
          ref="refItensAoVivo"
          :itens="itensAoVivo"
          :tab="visualizacaoAba"
          @selecionar="selecionar"
          @editarItem="editarItem"
          @transmitItem="transmitItem"
          @fonteItem="fonteItem"
          @excluirItem="excluirItem"
          @encerrar="encerrar"
          @williamhillVincular="vincularWilliamHill"
        />
      </div>

      <h2
        class="tituloJogos"
        v-if="
          retornaSite() !== 'Share' &&
          retornaSite() !== '7live' &&
          visualizacaoAba == false
        "
      >
        Previsto
      </h2>
      <h2
        class="tituloJogos"
        v-if="
          retornaSite() !== 'Share' &&
          retornaSite() == '7live' &&
          visualizacaoAba == false
        "
      >
        Possíveis Jogos
      </h2>

      <p
        v-if="
          itensPrevisto.length == 0 &&
          retornaSite() !== 'Share' &&
          (visualizacaoAba == false || abaSelecionada == 'previsto')
        "
        style="margin-bottom: 0px"
      >
        ------
      </p>

      <div
        class="rowLista"
        v-if="retornaSite() !== 'Share'"
        :style="{
          display:
            visualizacaoAba == false || abaSelecionada == 'previsto'
              ? 'block'
              : 'none',
        }"
      >
        <ListEventos
          ref="refItensPrevisto"
          :itens="itensPrevisto"
          :tab="visualizacaoAba"
          @selecionar="selecionar"
          @editarItem="editarItem"
          @transmitItem="transmitItem"
          @fonteItem="fonteItem"
          @excluirItem="excluirItem"
          @aoVivo="aoVivo"
          @williamhillVincular="vincularWilliamHill"
        />
      </div>

      <h2
        class="tituloJogos"
        v-if="retornaSite() !== 'Share' && visualizacaoAba == false"
      >
        Invisivel
      </h2>

      <p
        v-if="
          itensInvisivel.length == 0 &&
          retornaSite() !== 'Share' &&
          (visualizacaoAba == false || abaSelecionada == 'invisivel')
        "
        style="margin-bottom: 0px"
      >
        ------
      </p>

      <div
        class="rowLista"
        v-if="retornaSite() !== 'Share'"
        :style="{
          display:
            visualizacaoAba == false || abaSelecionada == 'invisivel'
              ? 'block'
              : 'none',
        }"
      >
        <ListEventos
          ref="refItensInvisivel"
          :itens="itensInvisivel"
          :tab="visualizacaoAba"
          @selecionar="selecionar"
          @editarItem="editarItem"
          @transmitItem="transmitItem"
          @fonteItem="fonteItem"
          @excluirItem="excluirItem"
          @williamhillVincular="vincularWilliamHill"
        />
      </div>

      <h2
        class="tituloJogos"
        v-if="retornaSite() !== 'Share' && visualizacaoAba == false"
      >
        Finalizado
      </h2>

      <p
        v-if="
          itensFinalizado.length == 0 &&
          retornaSite() !== 'Share' &&
          (visualizacaoAba == false || abaSelecionada == 'finalizado')
        "
        style="margin-bottom: 0px"
      >
        ------
      </p>

      <div
        class="rowLista"
        v-if="retornaSite() !== 'Share'"
        :style="{
          display:
            visualizacaoAba == false || abaSelecionada == 'finalizado'
              ? 'block'
              : 'none',
        }"
      >
        <ListEventos
          ref="refItensFinalizado"
          :itens="itensFinalizado"
          :tab="visualizacaoAba"
          @selecionar="selecionar"
          @editarItem="editarItem"
          @transmitItem="transmitItem"
          @fonteItem="fonteItem"
          @excluirItem="excluirItem"
          @williamhillVincular="vincularWilliamHill"
        />
      </div>

      <EditEvento ref="editItem" @save-item="carregarItens(false)" />
      <EditEventos
        ref="editItemEventos"
        @limparSelecao="limparSelecao"
        :selecionados="itensSelecionados"
        @salvarItens="salvarItens"
        @excluirItens="excluirItens"
      />

      <WilliamHill
        ref="williamHill"
        @concluido="carregarItens(true)"
      ></WilliamHill>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";

import EditEvento from "../edits/EditEvento.vue";
import EditEventos from "../edits/EditEventos.vue";
import ListEventos from "../lists/ListEventos.vue";
import WilliamHill from "../pages/WilliamHill.vue";

import Combo from "../components/Combo.vue";

export default {
  name: "Eventos",
  components: { ListEventos, EditEvento, EditEventos, Combo, WilliamHill },
  props: {
    itensLimit: { type: Number, default: 500 },
    tab: { type: Boolean, default: false },
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    selecionar(event, item) {
      var indexItem = this.itensSelecionados.indexOf(item._id);

      if (indexItem > -1) {
        this.itensSelecionados.splice(indexItem, 1);
      } else {
        this.itensSelecionados.push(item._id);
      }
    },
    clickSelecionados() {
      this.$refs.editItemEventos.limpar();
    },
    async carregarItens(auto) {
      var obj = this;

      if (auto && this.itensSelecionados.length > 0) {
        clearTimeout(this.timerRecarregar);

        this.timerRecarregar = setTimeout(function () {
          obj.carregarItens(true);
        }, 20000);

        return;
      }

      //* Limpar selecao
      this.limparSelecao();

      var filtros = "";

      filtros += "?_limit=" + this.itensLimit + "&_page=1&editar=1";

      if (this.filtroTexto !== "") {
        filtros += "&_all=" + this.filtroTexto;
      }

      if (this.filtroSite !== "Todos") {
        filtros += "&site=" + this.filtroSite;
      }

      const response = await api.get("/evento" + filtros);
      api.valid(response.data, this.$router);

      var arrItensPrevisto = [];
      var arrItensInvisivel = [];
      var arrItensAoVivo = [];
      var arrItensFinalizado = [];

      for (
        var indiceEvento = 0;
        indiceEvento < response.data.itens.length;
        indiceEvento++
      ) {
        var item = response.data.itens[indiceEvento];

        var inserirItem = false;

        if (this.filtroSite !== "Todos") {
          if (this.filtroSite == item.site) {
            inserirItem = true;
          }
        } else {
          inserirItem = true;
        }

        if (inserirItem) {
          item.selecionado = false;

          if (item.situacao == 1) {
            arrItensPrevisto.push(item);
          }

          if (item.situacao == 2) {
            arrItensInvisivel.push(item);
          }

          if (item.situacao == 3) {
            arrItensAoVivo.push(item);
          }

          if (item.situacao == 4) {
            arrItensFinalizado.push(item);
          }
        }
      }

      this.itensPrevisto = arrItensPrevisto;
      this.itensInvisivel = arrItensInvisivel;
      this.itensAoVivo = arrItensAoVivo;
      this.itensFinalizado = arrItensFinalizado;

      if (auto) {
        clearTimeout(this.timerRecarregar);

        this.timerRecarregar = setTimeout(function () {
          obj.carregarItens(true);
        }, 20000);
      }
    },
    editarItem(id) {
      this.$refs.editItem.carregarItem(id);
    },
    transmitItem(id) {

      var pageUrl = "transmit";

      if(this.retornaSite() == "7live")
      {
        pageUrl = "live";
      }

      window.open(
        "/" + pageUrl + "/" + id,
        "newwindow_" + Date.now(),
        "scrollbars=1,width=700,height=750",
        true
      );
    },
    fonteItem(link) {
      window.open(
        link,
        "newwindow_" + Date.now(),
        "scrollbars=1,width=450,height=500",
        true
      );
    },
    itemNovo() {
      this.$refs.editItem.novo();
    },
    limparSelecao() {
      if (this.$refs.refItensPrevisto) {
        this.$refs.refItensPrevisto.limparSelecionados(false);
      }

      if (this.$refs.refItensInvisivel) {
        this.$refs.refItensInvisivel.limparSelecionados(false);
      }

      if (this.$refs.refItensAoVivo) {
        this.$refs.refItensAoVivo.limparSelecionados(false);
      }

      if (this.$refs.refItensFinalizado) {
        this.$refs.refItensFinalizado.limparSelecionados(false);
      }

      this.itensSelecionados = [];
    },
    keyupFiltroTexto() {
      clearTimeout(this.timerFiltroTexto);

      var obj = this;

      this.timerFiltroTexto = setTimeout(function () {
        obj.carregarItens(false);
      }, 300);
    },
    async excluirItem(item) {
      var excluir = confirm("Deseja excluir o evento: " + item.nome);

      if (excluir == true) {
        await api.put("/evento/delete/" + item._id);
      }

      this.carregarItens(false);
    },
    salvarItens() {
      this.limparSelecao();
      this.carregarItens(false);
    },
    excluirItens() {
      this.limparSelecao();
      this.carregarItens(false);
    },
    async aoVivo(id) {
      var apiRequest;
      var body = {};

      if (confirm("Publicar como ao vivo ?")) {
        body.ids = [id];

        apiRequest = await api.put("/evento/aovivo", body);

        if (!apiRequest.data.erro) {
          this.carregarItens(false);
        }
      }
    },
    async encerrar(id) {
      var apiRequest;
      var body = {};

      if (confirm("Encerrar evento ?")) {
        body.ids = [id];

        apiRequest = await api.put("/evento/encerrar", body);

        if (!apiRequest.data.erro) {
          this.carregarItens(false);
        }
      }
    },
    async importarWilliamHill() {
      this.$refs.williamHill.abrir();
    },
    async vincularWilliamHill(_id) {
      this.$refs.williamHill.abrir("events", _id);
    },
    trocarAba(aba) {
      this.abaSelecionada = aba;
    },
    mostrarTab() {
      try {
        this.tab = !this.tab;
        localStorage.setItem("kjiConfigEventosTab", this.tab.toString());
      } catch (e) {
        console.log(e);
      }
    },
    exportItens(completo = true) {
      var conteudo = "";

      if (completo == true) {
        conteudo = "status\tdata\tnome\tpais\tcompeticao\tusuario\n";
      }

      var arrItensExport = [];

      if (
        this.visualizacaoAba.toString() == "false" ||
        this.abaSelecionada == "aovivo"
      ) {
        arrItensExport = arrItensExport.concat(this.itensAoVivo);
      }

      if (
        this.visualizacaoAba.toString() == "false" ||
        this.abaSelecionada == "previsto"
      ) {
        arrItensExport = arrItensExport.concat(this.itensPrevisto);
      }

      if (
        this.visualizacaoAba.toString() == "false" ||
        this.abaSelecionada == "invisivel"
      ) {
        arrItensExport = arrItensExport.concat(this.itensInvisivel);
      }

      if (
        this.visualizacaoAba.toString() == "false" ||
        this.abaSelecionada == "finalizado"
      ) {
        arrItensExport = arrItensExport.concat(this.itensFinalizado);
      }

      var ultimoTitulo = "";

      for (
        var indiceItem = 0;
        indiceItem < arrItensExport.length;
        indiceItem++
      ) {
        var item = arrItensExport[indiceItem];
        var itemStatus = "";

        //* Verifica situacao
        switch (item.situacao) {
          case 1:
            itemStatus = "Previsto";
            break;
          case 2:
            itemStatus = "Invisivel";
            break;
          case 3:
            itemStatus = "Ao Vivo";
            break;
          case 4:
            itemStatus = "Finalizado";
            break;
        }

        if (completo == true) {
          var itemData = "";

          try {
            itemData =
              item.dataDia.toString().padStart(2, "0") +
              "/" +
              item.dataMes.toString().padStart(2, "0") +
              "/" +
              item.dataAno +
              " " +
              item.dataHora.toString().padStart(2, "0") +
              ":" +
              item.dataMinuto.toString().padStart(2, "0");
          } catch (errData) {
            console.log(errData);
          }

          //this.formatDateTime(item.dataLancamento) +
          conteudo +=
            itemStatus +
            "\t" +
            itemData +
            "\t" +
            (item.nome ? item.nome : "") +
            "\t" +
            (item.pais ? item.pais : "") +
            "\t" +
            (item.competicao ? item.competicao : "") +
            "\t" +
            (item.usuarioCriacaoJoin && item.usuarioCriacaoJoin.length > 0
              ? item.usuarioCriacaoJoin[0].nome
              : "") +
            "\n";
        } else {
          if (ultimoTitulo !== itemStatus) {
            ultimoTitulo = itemStatus;
            conteudo += itemStatus + "\n";
          }

          conteudo +=
            item.dataHora.toString().padStart(2, "0") +
            ":" +
            item.dataMinuto.toString().padStart(2, "0") +
            " - " +
            (item.nome ? item.nome : "") +
            "\n";
        }
      }

      this.$copyText(conteudo).then(
        function (e) {
          alert("Copiado com sucesso!");
          console.log(e);
        },
        function (e) {
          alert("Impossivel copiar!");
          console.log(e);
        }
      );
    },
  },
  mounted() {
    try {
      var localConfigTab = localStorage.getItem("kjiConfigEventosTab");

      if (this.retornaSite() !== "Share" && localConfigTab == "true") {
        this.tab = true;
      }
    } catch (e) {
      console.log(e);
    }

    this.carregarItens(this.retornaSite() !== "7live");
  },
  data: function () {
    return {
      filtroTexto: "",
      timerFiltroTexto: 0,
      timerRecarregar: 0,
      filtroSite: "Todos",
      itens: [],
      itensPrevisto: [],
      itensInvisivel: [],
      itensAoVivo: [],
      itensFinalizado: [],
      itensSelecionados: [],
      situacao: {
        1: "Previsto",
        2: "Invisivel",
        3: "Ao Vivo",
        4: "Finalizado",
      },
      editItem: null,
      abaSelecionada: "aovivo",
    };
  },
  computed: {
    visualizacaoAba: function () {
      if (this.filtroTexto.trim().length > 0) {
        return false;
      }

      return this.tab;
    },
    pesquisaAtiva: function () {
      return this.filtroTexto.trim().length > 0;
    },
  },
};
</script>

<style>
.textoResumo {
  margin-bottom: 0px;
}
.rowLista {
  margin-bottom: 15px;
}

.rowDivisor {
  margin-top: 0px;
  margin-bottom: 15px;
  margin-top: 15px;
}

.inputPesquisa {
  max-width: 50%;
}

.inputPesquisaDupla {
  width: 97%;
  margin-left: 3%;
}

.botaoNovo {
  margin-top: 6px;
}
</style>
